import { render, staticRenderFns } from "./Eventos.vue?vue&type=template&id=ad48e628&scoped=true&"
import script from "./Eventos.vue?vue&type=script&lang=js&"
export * from "./Eventos.vue?vue&type=script&lang=js&"
import style0 from "./Eventos.vue?vue&type=style&index=0&id=ad48e628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad48e628",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VApp,VImg,VPagination})
